import { Dispatch } from 'redux'
import { validateOldPassword } from '../../../actions/userAccount/user/updatePassword'
import { IChangePasswordValues } from './withReduxForm'

export default function(values: IChangePasswordValues, dispatch: Dispatch) {
  dispatch(validateOldPassword(values.oldPassword, values.newPassword))
}
